<template>
  <transition name="fade">
    <div v-if="dialogShow" class="dialog-container" :style="{zIndex: curZIndex}" :class="position" @click="closeDialog">
      <div class="container" @click.stop>
        <div class="icon" @click="close">
          <el-icon><Close /></el-icon>
        </div>
        <div class="content column">
          <slot></slot>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import { Close } from '@element-plus/icons-vue'

export default {
  components: {
    Close
  },
  props: {
    autoClose: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'center' // 可选值：'center', 'left', 'right', 'top', 'bottom'
    }
  },
  data: () => {
    return {
      dialogShow: false,
      body: undefined,
      parent: undefined,
      curZIndex: 9
    }
  },
  mounted() {
    if (!window.$DialogZIndex) {
      window.$DialogZIndex = 9
    }
    this.curZIndex = window.$DialogZIndex;
    window.$DialogZIndex++;
    this.parent = this.$el.parentElement
    this.body = document.getElementById('app')
  },
  methods: {
    closeDialog() {
      if (this.autoClose) {
        this.dialogShow = false
        this.$emit('close')
      }
    },
    open() {
      this.show()
    },
    show() {
      this.dialogShow = true
      this.parent.removeChild(this.$el);
      this.body.append(this.$el);
    },
    hide() {
      this.close()
    },
    close() {
      this.dialogShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background-color: #0000001f;
  &.right {
    justify-content: flex-end;
    .container {
      margin-right: 40px;
    }
  }
  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    min-width: 300px;
    min-height: 150px;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 0 8px 0px #adadad7f;
    .content {
      height: auto;
    }
    .icon {
      position: absolute;
      top: 15px;
      right: 15px;
      cursor: pointer;
      transition: transform 0.3s;
      transform: scale(1.6);
      &:hover {
        transform: rotate(90deg) scale(2.2);
      }
    }
  }
}

/* 淡入淡出动画 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s, transform 0.6s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: scale(1.3);
}
.fade-enter-to, .fade-leave-from {
  opacity: 1;
}
</style>
